import {z} from "zod";


export const GetRelatedRangeRequestSchema = z.object({
    f: z.string().min(1), // related collection, ex finance
    r: z.string().min(1), // name of field
    p: z.string().regex(new RegExp(/\d{4}-\d{2}\/(\d{4}-\d{2})?/) ).describe('period ex. 2022-01/  or 2022-01/2023-02'),
    fp: z.string().min(1), // ex. c_period
});
export interface GetRelatedRangeRequestType extends z.infer<typeof GetRelatedRangeRequestSchema> { }


export const GetRelatedRangeResponseSchema = z.object({
    status: z.literal('ok'),
    range: z.object({
        min: z.number(),
        max: z.number(),
    })
});
export interface GetRelatedRangeResponseType extends z.infer<typeof GetRelatedRangeResponseSchema> { }


function getOnfulfilled(
    request: GetRelatedRangeRequestType,
    reject: (reason?: any) => void,
    resolve: (value: (PromiseLike<unknown> | unknown)) => void
) {
    return (data: GetRelatedRangeResponseType) => {
        try {
            GetRelatedRangeResponseSchema.parse(data);
        } catch (error) {
            console.debug('getRange, request', request);
            console.debug('getRange, response', data);
            console.error(`Error zod: ${error.message}`);
            reject(`Error zod: ${error.message}`);
        }
        if (data.status !== 'ok') {
            reject('Nie udało się pobrać danych z serwera. Spróbuj ponownie później');
        } else {
            resolve(data);
        }
    };
}

export class featureGetRelatedRange {

    public static async getRange(request: GetRelatedRangeRequestType): Promise<GetRelatedRangeResponseType> {
        return new Promise((resolve, reject) => {
            try {
                GetRelatedRangeRequestSchema.parse(request);
            } catch (error) {
                console.debug('getRange, request', request);
                console.error(`ZodError, ${error.message}`);
                reject(`Błąd na wejściu danych (getRange): ${error.message}`);
            }
            fetch('./index.php?action=rpc_relatedRange', {
                method: 'POST',
                body: JSON.stringify(request),
            }).then((response) => {
                return response.json();
            }).then(getOnfulfilled(request, reject, resolve)).catch((error) => {
                console.error('featureGetRange, getRange, error', error);
                reject('Błąd: ' + error);
            });
        });
    }

    private static convertRequestToString(request: GetRelatedRangeRequestType): {[key:string]: string} {
        // convert all values from request to string and save as new object
        let requestConvertedToString: { [key:string]: string} = {};
        Object.keys(request).forEach((key) => {
            requestConvertedToString[key] = request[key].toString();
        });
        return requestConvertedToString;
    }

    private static convertRequestToURLSearchParams(request: GetRelatedRangeRequestType): string {
        return new URLSearchParams(featureGetRelatedRange.convertRequestToString(request)).toString();
    }
    
}